<div class="flex row align-center justify-center bottom">
    @for (asset of data; track asset; let i = $index) {
        <div class="item flex-20">
            <a (click)="setIndex(i)">
                <img src="{{ asset.thumbnail }}" />
            </a>
        </div>
    }
</div>
